/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { PayOrder200ResponseData } from './PayOrder200ResponseData'
import {
  PayOrder200ResponseDataFromJSON,
  PayOrder200ResponseDataFromJSONTyped,
  PayOrder200ResponseDataToJSON,
} from './PayOrder200ResponseData'

/**
 *
 * @export
 * @interface PayOrder200Response
 */
export interface PayOrder200Response {
  /**
   *
   * @type {boolean}
   * @memberof PayOrder200Response
   */
  status: boolean
  /**
   *
   * @type {PayOrder200ResponseData}
   * @memberof PayOrder200Response
   */
  data: PayOrder200ResponseData
}

/**
 * Check if a given object implements the PayOrder200Response interface.
 */
export function instanceOfPayOrder200Response(
  value: object
): value is PayOrder200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function PayOrder200ResponseFromJSON(json: any): PayOrder200Response {
  return PayOrder200ResponseFromJSONTyped(json, false)
}

export function PayOrder200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PayOrder200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: PayOrder200ResponseDataFromJSON(json['data']),
  }
}

export function PayOrder200ResponseToJSON(
  value?: PayOrder200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: PayOrder200ResponseDataToJSON(value['data']),
  }
}
